<script lang="ts" setup>
import { Contact } from '@/models/contact.model';
import { PropType, ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Object as PropType<Contact>,
    required: true,
  },
  label: {
    type: String,
  },
  removable: {
    type: Boolean,
  },
  disabled: {
    type: Boolean,
  },
});

const contact = ref<Contact>({ ...props.modelValue });

const emit = defineEmits(['update:modelValue', 'change', 'remove']);

function update() {
  emit('update:modelValue', contact.value);
  emit('change', contact.value);
}

function remove() {
  emit('remove');
}

const languageOptions = [
  {
    title: 'NL',
    value: 'nl',
  },
  {
    title: 'EN',
    value: 'en',
  },
];

watch(
  () => props.modelValue,
  () => {
    contact.value = { ...props.modelValue };
  },
);
</script>
<template>
  <v-row dense v-if="label">
    <v-col
      ><h4>{{ label }}</h4></v-col
    >
  </v-row>
  <v-row dense>
    <v-col cols="3">
      <v-text-field
        v-model="contact.firstName"
        @change="update"
        :label="$t('initiative.edit.firstname')"
        density="compact"
        :disabled="disabled"
        :hide-details="true"
      ></v-text-field>
    </v-col>
    <v-col cols="3">
      <v-text-field
        v-model="contact.lastName"
        @change="update"
        :label="$t('initiative.edit.lastname')"
        density="compact"
        :disabled="disabled"
        :hide-details="true"
      ></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="contact.email"
        @change="update"
        :label="$t('initiative.edit.email')"
        density="compact"
        :disabled="disabled"
        :hide-details="true"
      ></v-text-field>
    </v-col>
    <v-col cols="2">
      <v-checkbox
        v-model="contact.main"
        @change="update"
        :label="$t('initiative.edit.main')"
        density="compact"
        :disabled="disabled"
        :hide-details="true"
      ></v-checkbox>
    </v-col>
  </v-row>
  <v-row dense>
    <v-col cols="5">
      <v-text-field
        v-model="contact.url"
        @change="update"
        :label="$t('initiative.edit.url')"
        density="compact"
        :disabled="disabled"
        :hide-details="true"
      ></v-text-field>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="contact.phone"
        @change="update"
        :label="$t('initiative.edit.phone')"
        density="compact"
        :disabled="disabled"
        :hide-details="true"
      ></v-text-field>
    </v-col>

    <v-col cols="2">
      <v-select
        :label="$t('initiative.edit.language')"
        density="compact"
        v-model="contact.language"
        :disabled="disabled"
        :items="languageOptions"
      />
    </v-col>

    <v-col cols="1" v-if="removable">
      <v-btn
        icon="mdi-delete-outline"
        class="remove-button mt-2"
        density="compact"
        v-if="!disabled"
        @click.prevent="remove"
      ></v-btn>
    </v-col>
  </v-row>
</template>
